import { FAQ } from "@/constants/testIds/site";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const items = [
  {
    q: "How long does the ClearShield application take?",
    a: "Most shower screens are completed within 1–2 hours. Larger conservatories or commercial jobs may take a full day. We'll give you an exact estimate before booking.",
  },
  {
    q: "Does ClearShield really last 10 years?",
    a: "Yes — when applied by a trained Ritec applicator on properly prepared glass. The coating bonds chemically with the glass surface, making it part of the glass itself.",
  },
  {
    q: "Will my glass need to be re‑cleaned more often?",
    a: "The opposite. ClearShield makes glass dramatically easier to clean. Most customers find a quick rinse and a soft cloth is all they need.",
  },
  {
    q: "What areas do you cover?",
    a: "We operate across the UK. For longer trips we'll typically batch nearby jobs together — get in touch and we'll let you know the next available date for your area.",
  },
  {
    q: "Can ClearShield be applied to old or worn glass?",
    a: "In many cases, yes. We'll assess the condition during the on‑site survey. Heavily etched or damaged glass may need professional restoration first — we'll advise honestly.",
  },
];

export default function FAQs() {
  return (
    <section
      data-testid={FAQ.section}
      className="relative py-24 md:py-32 px-6 md:px-10 bg-slate-50"
    >
      <div className="max-w-5xl mx-auto">
        <div className="text-xs font-bold tracking-[0.2em] uppercase text-emerald-700">
          Frequently asked
        </div>
        <h2 className="mt-4 font-display text-4xl md:text-5xl lg:text-6xl font-light tracking-tight">
          Quick answers to common <span className="italic font-semibold">questions</span>.
        </h2>

        <Accordion type="single" collapsible className="mt-10 space-y-3">
          {items.map((it, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={FAQ.item(i)}
              className="rounded-2xl border border-slate-200 bg-white px-6 data-[state=open]:shadow-md transition-shadow"
            >
              <AccordionTrigger className="font-display text-left text-lg font-semibold hover:no-underline py-5">
                {it.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-600 leading-relaxed pb-5">
                {it.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
